var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("© Copyright 2020-2020 - PnA Apps v1.0 - PnA Publicidade Ltda.")])])}]

export { render, staticRenderFns }